import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
// import { Snackbar, Fade, Button } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import AppAppBar from '../layouts/AppAppBar';
import Footer from '../layouts/Footer';

import AboutPlatform from '../components/AboutPlatform';
import ContactUS from '../components/ContactUS';
import FAQ from '../components/FAQ';

import defaultTheme from '../themes';

const LandingPage = () => {
  const [mode, setMode] = React.useState('light');
  const LPtheme = createTheme(defaultTheme(mode));
  // const [privacyOpen, setPrivacyOpen] = React.useState(true);

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  // const handleClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setPrivacyOpen(false);
  // };

  // const action = (
  //   <>
  //     <Button color="warning" variant="outlined" size="small" onClick={handleClose}>
  //       Prosseguir
  //     </Button>
  //   </>
  // );
  return (
    <ThemeProvider theme={LPtheme}>
      <CssBaseline />
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} success />
      {/* <Snackbar
        open={privacyOpen}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={10000}
        TransitionComponent={Fade}
        onClose={handleClose}
        message={`Sabemos que a sua privacidade é importante e por isso, não guardamos e ou rastreamos as suas informações.`}
        action={action}
        ContentProps={{
          sx: {
            background: '#FFFFFF',
            color: 'black',
            borderRadius: '10px',
            fontWeight: '600'
          }
        }}
      /> */}
      <Box sx={{ bgcolor: 'background.default' }}>
        <Divider />
        <AboutPlatform />
        <Divider />
        <FAQ />
        <Divider />
        <ContactUS />
        <Divider />
        <Footer mode={mode} />
      </Box>
    </ThemeProvider>
  );
};

export default LandingPage;
